import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton } from "@mui/material";
import { NavHashLink } from 'react-router-hash-link';
import Api from './Api';

function SSoft_Our_Partners() {
  const [sectionItems, setSectionItems] = useState([]);
  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const sectionData = sectionResponse;

      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let title;
  let partnerslogo;
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;
  
    secWidgets?.forEach((data, id) => {
      const secWidgetContents = data.widget_contents;
  
      switch (id) {
        case 0:
          title = secWidgetContents[0]?.content;
          break;
        case 2:
          partnerslogo = secWidgetContents
          break;
        default:
          break;
      }
    });
  }

  return (
    <div
      id={`${sectionItems?.slug_name}`}
      className="section-container section-margin-x h-full pb-[120px]  space-y-[80px]"
    >
      {sectionItems.length !== 0 ? (
        <>
          <div className="flex justify-center items-center">
            <h1 className="header-style-non-hero">{title}</h1>
          </div>
          <div className="w-full flex flex-col s:flex-row gap-x-8 gap-y-8 s:gap-y-0">
            {partnerslogo &&
              partnerslogo.map((partner) => (
                <NavHashLink
                  key={partner.id}
                  className="w-full h-[250px] sm:h-[290px] flex justify-center items-center shadow-2xl"
                  smooth
                  to={partner?.article_language?.path || "/"}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="max-w-[200px] sm:max-w-[250px] lg:max-w-[320px] max-h-[100px]"
                    src={partner?.assets[0]?.file_medium}
                    alt={partner?.article_language?.title}
                  />
                </NavHashLink>
              ))}
          </div>
        </>
      ) : (
        <Box className="w-full h-[300px]" />
        //   <Skeleton animation="wave" variant="rectangular" height={300} />
        // </Box>
      )}
    </div>
  );
}

export default SSoft_Our_Partners